// extracted by mini-css-extract-plugin
module.exports = {"verified":"icons_verified__EuO4K"};